export default function getProfilePhotoStoragePath(userId: string): string {
  return `/users/${userId}/images/profilePhoto`;
}
